
import React, { Component } from 'react';
import Slider from 'react-slick';
import _ from 'lodash';
import { Icon } from '.';

export default class Carousel extends Component {

  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };

  }

  handleNavigation(isDirectionLeft) {

    const { children } = this.props;
    const { index } = this.state;

    const method = (isDirectionLeft) ? 'slickPrev' : 'slickNext';
    this.slider[method]();

    let newIndex = (index + (isDirectionLeft ? -1 : 1)) % children.length;
    if (newIndex === -1) {
      newIndex = children.length - 1;
    }

    this.updateIndex(newIndex);

  }

  handleIndexChange(current, newIndex) {
    this.updateIndex(newIndex);
  }

  updateIndex(newIndex) {

    const { onChange } = this.props;
    const { index } = this.state;

    /* update internal state */

    if (index !== newIndex) {

      this.setState({
        index: newIndex,
      }, () => {

        /* callback */

        if (_.isFunction(onChange)) {
          onChange(newIndex);
        }

      });

    }

  }

  goto(index) {

    this.setState({
      index,
    }, () => {
      this.slider.slickGoTo(index, true);
    });

  }

  render() {

    const {
      children,
    } = this.props;

    return (
      <div className="carousel">
        <Icon
          name="chevron-left"
          onClick={this.handleNavigation.bind(this, true)}
        />
        <Slider
          ref={c => this.slider = c}
          className="carousel__slider"
          arrows={false}
          dots={false}
          infinite={true}
          speed={500}
          slidesToShow={1}
          slidesToScroll={1}
          beforeChange={this.handleIndexChange.bind(this)} /* `afterChange` is broken: `https://github.com/akiran/react-slick/issues/1262` */
        >
          {children}
        </Slider>
        <Icon
          name="chevron-right"
          onClick={this.handleNavigation.bind(this, false)}
        />
      </div>
    );

  }

}



// WEBPACK FOOTER //
// ./client/components/Carousel.jsx